import { TariffRate } from 'types/offerOptimizer';

export const UNLIMITED_QUANTITY = 9999999999;
export const UNLIMITED_QUANTITY_STRING = 'Unlimited';

export const DAYS_TO_WEEKS_CUTOFF = 20;
export const HOURS_TO_DAYS_CUTOFF = 72;
export const DEFAULT_BETTER_THAN_NEXT_BEST_PERCENTAGE_THRESHOLD = 0.01;
export const DEFAULT_BETTER_THAN_NEXT_BEST_DOLLARS_THRESHOLD = 10;
export const DEFAULT_MIN_BUYABLE_PERCENTAGE = 0.25;
export const WIRE_FEE_THRESHOLD = 2500;
export const WIRE_FEE = 55;
export const PAYMENT_PROCESSING_FEE = 0.06;

// Linear Programming model constants for Price Solver V2
export const DEFAULT_SHIPPING_COST = 25; // Default shipping cost when no options available (matches backend)
export const BIG_M_MULTIPLIER = 1000000; // Big M constant for binary constraints in LP model

export const landedCostFeeDescriptions = {
  managedPurchaseFee:
    'Cofactr Fees: Sourcing, Purchasing, Order Management, Traceability Management, Payment Processing',
  sourcingFee: 'Cofactr Fees: RFQ Management Services',
  tariff: 'Estimated Import Tariffs',
  supplierTariffAdjustment: 'Estimated Supplier Tariff Surcharge',
  supplierShipping: 'Supplier Shipping',
  supplierFreeShipping: 'Supplier Free Shipping',
  supplierPaymentProcessing: 'Supplier Payment Processing Fees',
  supplierWireTransfer: 'Wire Transfer Fees (Sender & Recipient)',
  customsBrokerage: 'Customs Brokerage',
  customsBrokerageDeminimis: 'Customs Brokerage (De Minimis Eligible Import)',
  customsBrokerageStandard: 'Customs Brokerage',
};

// This is a placeholder until we implement backend management of tariff rates in S2P-458
export const TARIFF_RATES: TariffRate[] = [
  {
    coo: ['CN', 'HK'],
    importCountry: 'US',
    tariffRate: 0.8,
    htsus: ['8541', '8542'],
  },
  {
    coo: ['CN', 'HK'],
    importCountry: 'US',
    tariffRate: 0.55,
    htsus: null,
  },
  {
    coo: null,
    importCountry: 'US',
    tariffRate: 0,
    htsus: null,
  },
];

export const DEMINIMIS_THRESHOLD = 800;
export const DEMINIMIS_EXCLUDED_COUNTRIES = ['CN', 'HK'];

export const CONFIRM_DAY_DELTA_NORMAL = 2;
export const CONFIRM_DAY_DELTA_QUOTE = 4;
